module.exports = __webpack_public_path__ + "media/promo/velle/images/play-192757ecfacbb37de9a22144c555d713.svg";